var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","align-content":"center"}},[_c('v-spacer'),_c('v-col',{attrs:{"cols":"6"}},[_c('v-card',[_c('v-card-text',[_c('v-file-input',{attrs:{"accept":"application/json"},on:{"change":_vm.uploadFile}})],1)],1)],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }